import React, { useState } from 'react';
import PropTypes from 'prop-types';
import { Translate } from 'react-localize-redux';
import Collapse from '@mui/material/Collapse';
import css from './GroupContainer.css';

const GroupContainer = ({
    title = '',
    open = false,
    children = null,
    style = {},
    titleStyle = {},
    controlled = false,
    onTitleClick = () => {},
    name = '',
    defaultOpen = false,
}) => {
    const [stateOpen, setStateOpen] = useState(defaultOpen);

    const handleTitleClick = () => {
        if (!controlled) {
            setStateOpen(!stateOpen);
            return;
        }
        onTitleClick(name);
    };

    const useOpen = controlled ? open : stateOpen;

    return (
        <div className={`${css.container} ${useOpen ? css.open : ''}`} style={style}>
            <div className={css.titleContainer} style={titleStyle} onClick={handleTitleClick}>
                <div className={css.arrow} />
                <div>
                    <Translate id={title} />
                </div>
            </div>

            <Collapse in={useOpen} timeout="auto" unmountOnExit>
                <div className={css.content}>{children}</div>
            </Collapse>
        </div>
    );
};

GroupContainer.propTypes = {
    open: PropTypes.bool,
    defaultOpen: PropTypes.bool,
    title: PropTypes.string,
    children: PropTypes.any, // eslint-disable-line react/forbid-prop-types,
    style: PropTypes.objectOf(PropTypes.any),
    titleStyle: PropTypes.objectOf(PropTypes.any),
    controlled: PropTypes.bool,
    onTitleClick: PropTypes.func,
    name: PropTypes.string,
};

export default GroupContainer;
